export default defineNuxtPlugin((nuxt) => {
  // Enable performance tracing in dev mode.
  // See:
  // - https://vuejs.org/api/application.html#app-config-performance
  // - https://vuejs.org/guide/best-practices/performance.html
  nuxt.vueApp.config.performance = true;
});
